(function () {
  const addDays = (date, days) => { const value = new Date(date); value.setDate(value.getDate() + days); return value; };
  const iso = (date) => date.toISOString().slice(0, 10);
  const parseLocalDate = (value) => new Date(value + 'T12:00:00');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'MAD', maximumFractionDigits: 0 }).format(cents / 100);
  const monthLabel = (date) => date.toLocaleDateString(document.documentElement.lang || 'en', { month: 'long', year: 'numeric' });

  function getAvailability(card) {
    const node = card.querySelector('[data-dhajia-availability-json]');
    if (!node) return [];
    try { const parsed = JSON.parse(node.textContent || '{}'); return Array.isArray(parsed.ranges) ? parsed.ranges : []; }
    catch (error) { return []; }
  }

  function rangesOverlap(arrivalValue, departureValue, ranges) {
    if (!arrivalValue || !departureValue) return null;
    const arrivalDate = parseLocalDate(arrivalValue);
    const departureDate = parseLocalDate(departureValue);
    return ranges.find((range) => {
      if (!range.start || !range.end) return false;
      return arrivalDate < parseLocalDate(range.end) && departureDate > parseLocalDate(range.start);
    }) || null;
  }

  function statusForDate(value, ranges) {
    const day = parseLocalDate(value);
    return ranges.find((range) => range.start && range.end && day >= parseLocalDate(range.start) && day < parseLocalDate(range.end));
  }

  function initBooking(card) {
    const arrival = card.querySelector('[data-dhajia-arrival]');
    const departure = card.querySelector('[data-dhajia-departure]');
    const quantity = card.querySelector('[data-dhajia-nights-input]');
    const estimate = card.querySelector('[data-dhajia-estimate]');
    const submit = card.querySelector('[data-dhajia-booking-submit]');
    const calendar = card.querySelector('[data-dhajia-calendar]');
    if (!arrival || !departure || !quantity || !estimate) return;
    const minimum = Number(card.dataset.minimumNights || 2);
    const price = Number(card.dataset.priceCents || 0);
    const unavailableRanges = getAvailability(card);
    const defaultButtonLabel = 'Continue to booking';
    const today = new Date(); today.setHours(12, 0, 0, 0);
    let viewDate = new Date(today.getFullYear(), today.getMonth(), 1, 12);
    let selectedStart = '';

    arrival.min = iso(today);
    departure.min = iso(addDays(today, minimum));

    const setSubmitDisabled = (disabled, label) => {
      if (!submit) return;
      submit.disabled = disabled;
      submit.toggleAttribute('aria-disabled', disabled);
      const textNode = Array.from(submit.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (textNode) textNode.textContent = (label || defaultButtonLabel) + ' ';
    };

    const update = () => {
      setSubmitDisabled(false);
      if (arrival.value) departure.min = iso(addDays(parseLocalDate(arrival.value), minimum));
      if (!arrival.value || !departure.value) { renderCalendar(); return; }
      const nights = Math.round((parseLocalDate(departure.value) - parseLocalDate(arrival.value)) / 86400000);
      if (nights < minimum) {
        departure.value = '';
        estimate.textContent = `Please choose at least ${minimum} nights.`;
        setSubmitDisabled(true, 'Choose valid dates');
        renderCalendar();
        return;
      }
      const overlap = rangesOverlap(arrival.value, departure.value, unavailableRanges);
      if (overlap) {
        estimate.innerHTML = `<strong>Unavailable</strong><span>${overlap.label || 'Booked'} from ${overlap.start} to ${overlap.end}. Please choose different dates or message us on WhatsApp.</span>`;
        setSubmitDisabled(true, 'Dates unavailable');
        renderCalendar();
        return;
      }
      quantity.value = nights;
      estimate.innerHTML = `<strong>${nights} nights</strong><span>Estimated stay ${formatMoney(price * nights)}</span>`;
      renderCalendar();
    };

    const selectDate = (value) => {
      if (statusForDate(value, unavailableRanges) || parseLocalDate(value) < today) return;
      if (!selectedStart || (arrival.value && departure.value) || parseLocalDate(value) <= parseLocalDate(selectedStart)) {
        selectedStart = value;
        arrival.value = value;
        departure.value = '';
        estimate.textContent = `Now choose a departure date of at least ${minimum} nights.`;
        setSubmitDisabled(true, 'Choose departure');
        renderCalendar();
        return;
      }
      departure.value = value;
      selectedStart = '';
      update();
    };

    function renderCalendar() {
      if (!calendar) return;
      const year = viewDate.getFullYear();
      const month = viewDate.getMonth();
      const first = new Date(year, month, 1, 12);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const mondayOffset = (first.getDay() + 6) % 7;
      let html = `<div class="dhajia-calendar__head"><strong aria-live="polite" aria-atomic="true">${monthLabel(first)}</strong><div class="dhajia-calendar__nav"><button type="button" data-dhajia-cal-prev aria-label="Previous month">‹</button><button type="button" data-dhajia-cal-next aria-label="Next month">›</button></div></div>`;
      html += '<div class="dhajia-calendar__week"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div><div class="dhajia-calendar__grid">';
      for (let i = 0; i < mondayOffset; i++) html += '<button type="button" class="dhajia-calendar__day is-empty" disabled></button>';
      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day, 12);
        const value = iso(date);
        const blocked = statusForDate(value, unavailableRanges);
        const past = date < today;
        const selected = arrival.value && departure.value && date >= parseLocalDate(arrival.value) && date < parseLocalDate(departure.value);
        const isArrival = arrival.value === value;
        const isDeparture = departure.value === value;
        const classes = ['dhajia-calendar__day'];
        if (past) classes.push('is-past');
        if (blocked) classes.push('is-unavailable');
        if (selected) classes.push('is-selected');
        if (isArrival) classes.push('is-arrival');
        if (isDeparture) classes.push('is-departure');
        const accessibleLabel = date.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + (isArrival ? ' — arrival selected' : isDeparture ? ' — departure selected' : selected ? ' — selected stay' : blocked ? ' — ' + (blocked.label || 'Blocked') : '');
      const label = blocked ? `<small>${blocked.label || 'Blocked'}</small>` : '';
        html += `<button type="button" class="${classes.join(' ')}" data-dhajia-cal-day="${value}" aria-label="${accessibleLabel}" aria-pressed="${selected || isArrival || isDeparture ? 'true' : 'false'}" ${past || blocked ? 'disabled' : ''}>${day}${label}</button>`;
      }
      html += '</div><div class="dhajia-calendar__legend"><span>Available</span><span class="is-blocked">Booked/blocked</span><span class="is-selected">Selected stay</span></div>';
      calendar.innerHTML = html;
      calendar.querySelector('[data-dhajia-cal-prev]')?.addEventListener('click', () => { viewDate = new Date(year, month - 1, 1, 12); renderCalendar(); });
      calendar.querySelector('[data-dhajia-cal-next]')?.addEventListener('click', () => { viewDate = new Date(year, month + 1, 1, 12); renderCalendar(); });
      calendar.querySelectorAll('[data-dhajia-cal-day]').forEach((button) => button.addEventListener('click', () => selectDate(button.dataset.dhajiaCalDay)));
    }

    arrival.addEventListener('change', () => { selectedStart = arrival.value; update(); });
    arrival.addEventListener('input', () => { selectedStart = arrival.value; update(); });
    departure.addEventListener('change', update);
    departure.addEventListener('input', update);
    renderCalendar();
  }

  function initHospitable(host) {
    const statusText = host.querySelector('[data-dhajia-widget-status-text]');
    const statusLine = host.querySelector('.dhajia-booking__hospitable-status');
    const propertyName = host.dataset.dhajiaWidgetName || 'this DHAJIA stay';
    const readyLabel = host.dataset.dhajiaWidgetReady || 'Live availability ready';
    const delayedLabel = host.dataset.dhajiaWidgetDelayed || 'Live calendar is taking longer than expected';
    const titleTemplate = host.dataset.dhajiaWidgetTitle || 'Select dates and guests for [property]';
    let observer;
    let loadTimer;

    const markReady = (iframe) => {
      if (host.querySelector('iframe') !== iframe) return;
      iframe.title = titleTemplate.replace('[property]', propertyName);
      host.removeAttribute('aria-busy');
      if (statusLine) {
        statusLine.style.visibility = '';
        statusLine.removeAttribute('aria-hidden');
      }
      if (statusText) statusText.textContent = readyLabel;
      if (observer) observer.disconnect();
      window.clearTimeout(loadTimer);
    };

    const watchIframe = (iframe) => {
      if (!iframe || iframe.dataset.dhajiaLoadWatched) return;
      iframe.dataset.dhajiaLoadWatched = 'true';
      iframe.title = titleTemplate.replace('[property]', propertyName);
      iframe.addEventListener('load', () => markReady(iframe), { once: true });
      // The cross-origin frame may have loaded before this deferred script.
      // Suppress unverified status, retain its space, and keep the fallback link.
      host.removeAttribute('aria-busy');
      if (statusLine) {
        statusLine.style.visibility = 'hidden';
        statusLine.setAttribute('aria-hidden', 'true');
      }
      window.clearTimeout(loadTimer);
    };

    observer = new MutationObserver(() => watchIframe(host.querySelector('iframe')));
    observer.observe(host, { childList: true, subtree: true });
    loadTimer = window.setTimeout(() => {
      if (host.querySelector('iframe')) return;
      host.removeAttribute('aria-busy');
      if (statusText) statusText.textContent = delayedLabel;
    }, 12000);
    watchIframe(host.querySelector('iframe'));
  }

  function initGallery(gallery) {
    const track = gallery.querySelector('.dhajia-gallery__mosaic');
    const current = gallery.querySelector('[data-dhajia-gallery-current]');
    if (track && current) {
      let galleryFrame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(galleryFrame);
        galleryFrame = requestAnimationFrame(() => { current.textContent = String(Math.round(track.scrollLeft / track.clientWidth) + 1); });
      }, { passive: true });
    }
    const dialog = gallery.querySelector('[data-dhajia-gallery-dialog]');
    if (!dialog) return;
    gallery.querySelectorAll('[data-dhajia-gallery-open]').forEach((button) => button.addEventListener('click', () => {
      dialog.showModal();
      const target = dialog.querySelector(`#DhajiaPhoto-${gallery.closest('[id^="MainProduct-"]')?.id.replace('MainProduct-', '')}-${button.dataset.dhajiaGalleryOpen}`);
      if (target) setTimeout(() => target.scrollIntoView({ block: 'start' }), 50);
    }));
    dialog.querySelector('[data-dhajia-gallery-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  }

  document.querySelectorAll('[data-dhajia-booking]').forEach(initBooking);
  document.querySelectorAll('[data-dhajia-hospitable]').forEach(initHospitable);
  document.querySelectorAll('[data-dhajia-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-dhajia-scroll-booking]').forEach((control) => control.addEventListener('click', (event) => {
    const selector = control.getAttribute('href');
    const target = selector ? document.querySelector(selector) : document.querySelector('[data-dhajia-booking]');
    if (!target) return;
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
  }));
})();

(function () {
  'use strict';
  function initVideoTours() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (product) {
      const summary = product.querySelector('.dhajia-stay-summary');
      const film = product.querySelector('.dhajia-property-film');
      if (!summary || !film || !film.querySelector('video source[src], video[src]')) return;
      if (summary.querySelector('[data-dhajia-scroll-video]')) return;
      const save = summary.querySelector('.dhajia-product-save');
      const facts = summary.querySelector('.dhajia-primary-facts');
      if (!facts) return;
      if (!film.id) film.id = 'DhajiaVideo-' + product.id;
      film.tabIndex = -1;
      const actions = document.createElement('div');
      actions.className = 'dhajia-stay-actions';
      const link = document.createElement('a');
      link.className = 'dhajia-video-tour';
      link.href = '#' + film.id;
      link.dataset.dhajiaScrollVideo = 'true';
      link.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"></circle><path d="m10 7 7 5-7 5Z"></path></svg><span>Watch video tour</span>';
      facts.insertAdjacentElement('afterend', actions);
      if (save) actions.appendChild(save);
      actions.appendChild(link);
      if (!save) {
        const observer = new MutationObserver(function () {
          const addedSave = summary.querySelector('.dhajia-product-save');
          if (addedSave) {
            actions.insertBefore(addedSave, link);
            observer.disconnect();
          }
        });
        observer.observe(summary, { childList: true });
      }
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        film.focus({ preventScroll: true });
        film.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideoTours);
  else initVideoTours();
  document.addEventListener('shopify:section:load', initVideoTours);
})();
